// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer_disclaimer__20lNM","open":"Disclaimer_open__1BLIZ","expand":"Disclaimer_expand__RbR3j"};